// extracted by mini-css-extract-plugin
export default {"imageWrapper":"QG-z","hovered":"RG-z","hoverImage":"SG-z","mainImage":"TG-z","imageNoBackground":"UG-z","fullSizeImage":"VG-z"};